import moment from 'moment';

export const submissionStatuses = {
  submitted: {
    display: 'Submitted',
    classModifier: 'submitted'
  },
  submittedLate: {
    display: 'Submitted Late',
    classModifier: 'submitted-late'
  },
  notSubmitted: {
    display: 'Not Submitted',
    classModifier: 'not-submitted'
  }
};

export function getSubmissionStatus(student, section, assignment) {
  const sectionData = student
    .getSectionRelationships().get(section.getId());
  const submittedAt = sectionData.getSubmittedAt();
  if (!submittedAt) {
    return submissionStatuses.notSubmitted;
  }
  return moment(submittedAt).isBefore(assignment.getDueDate())
    ? submissionStatuses.submitted
    : submissionStatuses.submittedLate;
}
